module.exports = "/_next/static/images/a7c593adc18e3d52249c4e86fa6083ed-boy-looking-to-the-front-md@1x.jpg";